import { academyAPI } from '../../../API/academy.api';

export const getNowDate = () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return { day, month, year}
}

export const format = (time) => {   
    const hrs = ~~(time / 3600);
    const mins = ~~((time % 3600) / 60);
    const secs = ~~time % 60;
    let ret = "";
    if (hrs > 0) {
        ret += "" + hrs + "" + "h" + "" + (mins < 10 ? "0" : "");
    }
    ret += " " + mins + "m" + " " +(secs < 10 ? "0" : "");
    ret += "" + secs + "s";
    return ret;
}


export const isAllLessonsFinished = (lessons, finishedLessonsIds) => {
    const notFinished = [];

    lessons.map(item => {
        if(!finishedLessonsIds.includes(item.id)){
            notFinished.push(item.id);
        }
    });

    return notFinished.length === 0;
}

export const isItemFinished = (key, ids) => ids.includes(key);

export const getNotFinishedTime = (item, ids) =>  {
    let percent = 0;
    ids.map(i => {
        if(i.id === item.id){
            percent = i.percent
        }
    })
    return percent;
}

export const deleteFromNotFinishedLessons = (item, ids) => ids.filter(id => id.id !== item.id);

export const add = () => console.log('add');

export const del = () => console.log('delete');

export const change = () => console.log('chnage');


export const sendNotificationAfterAddedChangeVideo = (id, title) => {
    academyAPI.sendNotificationAfterAddedChangeVideo(id, title)
    .then(res => console.log(res))
    .catch(err => console.log(err))
}

export const saveNotFinishedLessons = (data, id, percent, currentTime) => {
    const notCompleteLessons = [...data];
    const index = notCompleteLessons.findIndex(x => x.id === id);
    if(index === -1){
        notCompleteLessons.push({
            id,
            percent,
            time: currentTime
        })
    }else{
        notCompleteLessons.splice(index, 1, {
            id,
            percent,
            time: currentTime
        })
    }

    return notCompleteLessons;
}
